<template>
<div>
    <div class="base_head"> 
          <el-carousel class :arrow="bannerDatas.length > 1 ? 'hover' : 'never'" :interval="4000" v-if="isBanners" :indicator-position="indicator">
        <el-carousel-item v-for="(item, index) in bannerDatas" :key="index" class="img_box">
          <div :class="item.banner">
            <el-row class="container margin-banner">
              <el-col :span="14" style="text-align: left;margin-left: -100px;" :style="{color:color}"  >
                <h3 class="LOT-title1">{{ item.title.substring(0, 8)}}</h3>
                <h3 class="LOT-title2">{{ item.title.substring(8, 16)}}</h3>
                <p class="LOT-in" >{{ item.content }}</p>
                <button class="apply-button" @click="isShow = true">{{ item.button }}</button>
              </el-col>
            </el-row>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <plan-dialog
      :isShow="isShow"
      v-if="isShow"
      @closeTop="closeTop"
    ></plan-dialog>
    </div>
</template>
<script>
import planDialog from "@components/planDialog.vue"
import mixin from '@/mixin/index.js'
export default {
  mixins: [mixin],
  components: {
    planDialog,
  },
  props: {
    bannerData: {
      type: [Array],
      default: () => []
    },
    active: {
      type: [Number, String],
      default: 0
    },
    isBanner: {
      type: [Boolean],
      default: true
    },
    isGif: {
      type: [Boolean],
      default: true
    },
    bannerLists: {
      type: [Array],
      default: () => []
    },
    color:{
      type:[String],
      default:'black'
    },
	textColor:{
		type:[String],
		default:'black'
	},
    indicator:{
      type:[String],
      default:''
    }
  },
  data() {
    return {
      count: 0,
      messageShow: false,
      isShow: false,
      bannerDatas: this.bannerData,
      activeIndex: this.active,
      mouseIndex: this.active,
      isBanners: this.isBanner,
      isGifs: this.isGif,
      list: [
        {
          path: '/home',
          name: '首页',
          index: 0
        },
        {
          path: '/internet',
          name: '智能网联',
          index: 1
        },
        {
          path: '/serve',
          name: '物联网',
          index: 2
        },
        {
          path: '/intelligentize',
          name: '数智化',
          index: 3
        },
        {
          path: '/economy',
          name: '低空经济',
          index: 4
        },
        {
          path: '/aboutUs',
          name: '关于我们',
          index: 5
        },
      ],
      bannerList: this.bannerLists,
      isFixed: false,
      style: {},
      opacity: 0
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      let offsetTop = document.querySelector('#boxFixed').offsetTop;  // 要滚动到顶部吸附的元素的偏移量
      this.isFixed = scrollTop > offsetTop + 100 ? true : false;
    },
    closeTop() {
      this.isShow = false;
    },
    select(index) {

      if(index !== 1){
        let paths = this.list[index].path;
      }
    },
    mouseenter(index) {
      this.mouseIndex = index
      console.log('activeIndex--',this.activeIndex)
    },
    mouseleave() {
      this.mouseIndex = ''
    },
    getSqlCheck() {
      this.$router.push({ path: '/home' })
      if (this.count === 0) {
        this.startTime = new Date();
        this.lastTime = this.startTime;
      } else if (this.count >= 1) {
        let nextTime = new Date();
        if (nextTime - this.startTime >= 1500) {
          // 超过五秒重置
          this.startTime = nextTime;
          this.lastTime = nextTime;
          this.count = 0;
        } else {
          this.lastTime = nextTime;
        }
        if (this.count === 5) {
          // 大于三次重置
          this.sqlCheck(true);
          this.startTime = nextTime;
          this.lastTime = nextTime;
          this.count = 0;
        }
      }
      this.count++;
      // console.log(this.count);
    },
    sqlCheck(flag) {
      console.log(flag)
      this.$router.push({ path: '/test' })
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll); // 离开页面 关闭监听 不然会报错
  }
};
</script>

<style lang="scss" scoped>
.backTop{
  bottom: 100px !important;
  right: 24px !important;
  width: 44px;
  height: 44px;
  background: linear-gradient(180deg, #f2f5fa, #fefefe);
  border: 2px solid #ffffff;
  border-radius: 4px;
  box-shadow: 2px 6px 10px #59585814; 
  i{font-size: 24px; }
  :deep(.el-icon-caret-top){font-size: 24px;}
}
//头部
.base_head {
  z-index: 99;
  position: relative;
  height: auto;
  //导航栏起始
  .flex-center {
    display: flex;
    justify-content: center;
  }
  .flexs {
    display: flex;
    min-width: 1400px;
    margin: 0 auto;
    align-items: center;
    justify-content: space-between;
  }

  .logo-h1 {
    display: none;
  }
  .navs {
    background: #ffffff;
    backdrop-filter: blur(16px);
    // position: absolute;
    z-index: 99;
    width: 100%;
  }
  .logoImg {
    width: 132px;
    height: 32px;
    opacity: 1;
    cursor: pointer;
  }
  .fixedBar {
    width: 100%;
    color: #fff;
    z-index: 100;
    position: fixed;
    background: #ffffff;
    top: 0;
    box-shadow: 2px 6px 10px #59585814;
  }

  .navitem {
    margin-left: 48px;
    // height: 60px;
    text-align: center;
    line-height: 64px;
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    color: #4d4d4d;
    cursor: pointer;
    .router-link{
      span {
        font-size: 16px !important;
      }
    } 
  }
  ::v-deep .navitem.is-active {
    font-size: 16px !important;
    font-weight: 700;
    color: #1e77ec !important;
    position: relative;
  }
  .navitem.is-active {
    font-size: 16px !important;
    font-weight: 700;
    color: #1e77ec !important;
    position: relative;
  }
  .navitem.mou-active {
    font-size: 16px;
    font-weight: 700;
    color: #1e77ec !important;
    position: relative;
  }
  //导航栏结束

  //轮播图起始
  .el-carousel {
    height: 544px;
    overflow: hidden;
    .el-carousel__container {
      height: 544px;
    }
  }
  .margin-banner {
    margin-top: 80px !important;
  }
  //申请试用按钮
  .apply-button {
    margin-top: 150px;
    width: 136px;
    height: 44px;
    background: #0063E6;
    border-radius: 4px;
    font-weight: 400;
    color: #ffffff;
    font-size: 16px;
    border: none;
    cursor: pointer;
  }
  .apply-button:hover {
    background: #0041E6;
    color: #fff;
  }
  .el-carousel {
    height: 640px;
    .el-carousel__container {
      height: 640px;
    }
    ::v-deep .el-carousel__container{
      height: 100%;
    }
  }

  .el-carousel__indicators {
    bottom: 102px;
    li {
      width: 47px;
      height: 3px;
      opacity: 0.38;
      background: #ffffff;
      border-radius: 2px;
      padding: 0;
      margin: 0 4px;
      background: #2b4fc7;
      border-radius: 1px;
      .el-carousel__button {
        width: auto;
        height: auto;
      }
    }
    .el-carousel__indicator.is-active {
      opacity: 1;
      background: #1e77ec;
      button {
        width: auto;
        height: auto;
      }
    }
  }

  .img_box {
    width: 100%;
    .banner_item {
      color: #475669;
      font-size: 18px;
      opacity: 0.75;
      line-height: 420px;
      margin: 0;
      height: 420px;
    }
  }
  //轮播图样式
  .digital_bg{
    background: url("../../public/img/intelligentize/pic_szh_banner.png") no-repeat;
    position: relative;
    background-size: 100% 100%;
    height: 640px;
    position: absolute;
    width: 100%;
    .dynamic-img {
      width: 420px;
      text-align: right;
      margin-top: 5px;
    }
    .LOT-title1 {
      font-size: 40px;
      font-weight: 600;
      margin-top: 99px;
      text-align: left;
      font-family: PingFang SC, PingFang SC-500;
    }
    .LOT-title2 {
      font-size: 40px;
      font-weight: 600;
      text-align: left;
      font-family: PingFang SC, PingFang SC-500;
    }
  }
  .digital_bg1{
    background: url("../../public/img/internet/车联网banner.png") no-repeat;
    position: relative;
    background-size: 100% 100%;
    height: 640px;
    position: absolute;
    width: 100%;
    .dynamic-img {
      width: 420px;
      text-align: right;
      margin-top: 5px;
    }
    .LOT-title1 {
      font-size: 40px;
      font-weight: 600;
      margin-top: 99px;
      text-align: left;
      font-family: PingFang SC, PingFang SC-500;
    }
    .LOT-title2 {
      font-size: 40px;
      font-weight: 600;
      text-align: left;
      font-family: PingFang SC, PingFang SC-500;
    }
  }
  .digital_bg2{
    background: url("../../public/img/internet/智联产品banner.png") no-repeat;
    position: relative;
    background-size: 100% 100%;
    height: 640px;
    position: absolute;
    width: 100%;
    .dynamic-img {
      width: 420px;
      text-align: right;
      margin-top: 5px;
    }
    .LOT-title1 {
      font-size: 40px;
      font-weight: 600;
      margin-top: 99px;
      text-align: left;
      font-family: PingFang SC, PingFang SC-500;
    }
    .LOT-title2 {
      font-size: 40px;
      font-weight: 600;
      text-align: left;
      font-family: PingFang SC, PingFang SC-500;
    }
  }
  .digital_bg3{
    background: url("../../public/img/internet/全球链接banner.png") no-repeat;
    position: relative;
    background-size: 100% 100%;
    height: 640px;
    position: absolute;
    width: 100%;
    .dynamic-img {
      width: 420px;
      text-align: right;
      margin-top: 5px;
    }
    .LOT-title1 {
      font-size: 40px;
      font-weight: 600;
      margin-top: 99px;
      text-align: left;
      font-family: PingFang SC, PingFang SC-500;
    }
    .LOT-title2 {
      font-size: 40px;
      font-weight: 600;
      text-align: left;
      font-family: PingFang SC, PingFang SC-500;
    }
  }
  .digital_bg4{
    background: url("../../public/img/internet/暖通行业解决方案.png") no-repeat;
    position: relative;
    background-size: 100% 100%;
    height: 640px;
    position: absolute;
    width: 100%;
    .dynamic-img {
      width: 420px;
      text-align: right;
      margin-top: 5px;
    }
    .LOT-title1 {
      font-size: 40px;
      font-weight: 600;
      margin-top: 99px;
      text-align: left;
      font-family: PingFang SC, PingFang SC-500;
    }
    .LOT-title2 {
      font-size: 40px;
      font-weight: 600;
      text-align: left;
      font-family: PingFang SC, PingFang SC-500;
    }
  }
  .software_bg{
    background: url("../../public/img/software/pic_rjyf_banner.png") no-repeat;
    position: relative;
    background-size: 100% 100%;
    height: 640px;
    position: absolute;
    width: 100%;
    .dynamic-img {
      width: 420px;
      text-align: right;
      margin-top: 5px;
    }
    .LOT-title {
      font-size: 40px;
      font-weight: 600;
      margin-top: 99px;
      text-align: left;
      font-family: PingFang SC, PingFang SC-500;
    }
  }
  .LOT-in {
    margin-top: 16px;
	color: #6E747A;
    width: 705px;
    height: 52px;
    font-size: 24px;
    font-weight: 400;
    text-align: left;
    line-height: 35px;
  }
  //轮播图结束

}
.hoverMsg{
  position: fixed;
  bottom: 160px;
  right: 24px;
  z-index: 999;
  display: flex;
  align-items: flex-end;
}
.visibility{
  visibility: hidden;
}
.sideMenu:hover,.message-box:hover{
  box-shadow: 8px 8px 24px 0px rgb(0 55 128 / 16%);
  transition: all 0.3s cubic-bezier(0, 0, 0.5, 1);
}

//联系我们
.sideMenu {
  margin-top: 10px;
  width: 44px;
  bottom: 160px;
  height: 118px;
  background: linear-gradient(180deg, #f2f5fa, #fefefe);
  border: 2px solid #ffffff;
  border-radius: 4px;
  box-shadow: 2px 6px 10px #59585814;
  // position: fixed;
  right: 24px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  z-index: 999;
  cursor: pointer;
  span {
    width: 14px;
    font-size: 14px;
    font-weight: 400;
    color: #0063e6;
    line-height: 18px;
  }
}
//在线留言
.message-box {
  margin-top: 10px;
  // display: none;
  width: 293px;
  height: 145px;
  background: linear-gradient(180deg, #f2f5fa, #fefefe);
  border: 2px solid #ffffff;
  border-radius: 4px;
  box-shadow: 0px 3px 14px 0px #e4e9f2;
  position: relative;
  // right: 80px;
  z-index: 999;
  text-align: left;
  
  bottom: -27px;
  margin-right: 20px;
  .lineB {
    // background: #98a3af;
    // height: 1px;
    // width: 290px;
    background: #dcdee1;
    height: 1px;
    width: 100%;
    // margin-left: 41px;
  }
  .online {
    padding: 16px 0 15px 13px;
    h3 {
      display: inline-block;
      margin-left: 13px;
      font-size: 16px;
      font-weight: 400;
    }
    img {
      margin-left: 5px;
    }
    p {
      color: #98a3af;
      margin-left: 39px;
    }
  }
}

//页面的公共样式
.tab-padding {
  overflow: hidden;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 8px 24px 0px rgba(155, 178, 212, 0.23);
  .el-tabs {
    margin: 12px 24px 24px;
  }
}
.main-bottom {
  padding-bottom: 78px !important;
}

.bg-box {
  background: linear-gradient(180deg, #f3f5f8, #fefefe);
  border: 2px solid #ffffff;
  border-radius: 4px;
  box-shadow: 0px 3px 14px 0px #f0f3f8;
}

.el-row {
  padding: 10px 0 40px;
}
//tab选项卡
.el-tabs__item.is-active {
  font-weight: 700;
  text-align: center;
  color: #161719;
}
//tab选项卡的下划线颜色
.el-tabs__active-bar {
  background: linear-gradient(90deg, #0063e6, #9cc6fe);
}
.el-tabs__header {
  margin-bottom: 30px;
}
:deep(.base_head .el-carousel__indicators li){
  width: 32px;
}
.base_head .el-carousel__indicators li{
  width: 32px;
}
.is-active {
    font-size: 16px;
    font-weight: 700;
    color: #1e77ec !important;
    position: relative;
  }

.LOT-title, .LOT-title1, .LOT-title2, h3 {
  font-weight: 600 !important;
  font-family: PingFang SC, PingFang SC-500;
}

</style>